import { render } from "./productListItemEdit.vue?vue&type=template&id=f2ff8686"
import script from "./productListItemEdit.vue?vue&type=script&lang=js"
export * from "./productListItemEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__